
import * as THREE from 'three'
require('three-orbitcontrols');

import printModel from '../../../3dapps/mixins/printModel';
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Range from 'vux/src/components/range/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


import { initThree, camera, scene, renderer, currentModel, updateModel } from './initThree';
import { getThreeFonts } from '../../../3dapps/js/fontManage.js';
import loading from '@/components/loading';

const contentList = [
"每天进步一点点",
"不负青春,不负自己",
"如家酒店",
"天虹商场",
"深圳齐思印商贸科技有限公司",
"星际大厦"
];

export default {
name: "signText",
mixins: [printModel],
components: {
XDialog, loading, Range, Cell
},
data() {
return {
quotationName: "招牌文字",
productType: "招牌文字",
landscape: true,//竖屏状态要一直为true
showPrint: false,
showText: false,
showSize: false,
showFonts: false,
showLoading: false,
showbtnSure: true,
addCartIndex: -1,
orderIndex: -1,
isreliefBtnIndex: -1,//顶部按钮默认
fontsItemIndex: 1,//初始值-字体
fontsData: [],
signText: {
h: 250, // 高
depth: 10,//厚度
thickness: 1.5, // 壁厚
text: contentList[Math.floor(Math.random() * contentList.length)],
font: "",
},
btnsList: [//按钮列表
{
isClick: false,
icon: require("../../../3dapps/imgs/nowImgs/文字.png"),
iconClick: require("../../../3dapps/imgs/nowImgs/文字选中.png"),
title: "文字",
},
{
isClick: false,
icon: require("../../../3dapps/imgs/nowImgs/字体.png"),
iconClick: require("../../../3dapps/imgs/nowImgs/字体选中.png"),
title: "字体",
},
{
isClick: false,
icon: require("../../../3dapps/imgs/nowImgs/尺寸.png"),
iconClick: require("../../../3dapps/imgs/nowImgs/尺寸选中.png"),
title: "尺寸",
},
],
}
},
mounted() {
const scope = this;
scope.showLoading = true;
scope.loadlistBrand();

var mo = function (e) {
e.preventDefault();
}


scope.$nextTick(function () {
scope.$refs.signText.style.paddingTop = '0px';
scope.$refs.signText.style.overflow = 'hidden';
scope.$refs.canvasBox.addEventListener("touchmove", mo, false);
});


const contentDOM = scope.$refs.signText;

const resize1 = function (e) {
if (!scope.$refs.canvas) return;


let w = scope.$refs.canvasBox.clientWidth;
let h = scope.$refs.canvasBox.clientHeight;



scope.$refs.canvas.width = w; 
scope.$refs.canvas.height = h; 



camera.aspect = w / h;

camera.updateProjectionMatrix();

renderer.setSize(w, h);
}

scope.init3d(contentDOM, camera, renderer, resize1);

initThree(scope.$refs.canvas);

setTimeout(function () {
scope.showLoading = false;
}, 50);
},
methods: {

loadData() {
const scope = this;
if (window.localStorage) {
let dataStr = localStorage.getItem("signText");
localStorage.removeItem("signText"); 
if (dataStr) {
let data = JSON.parse(dataStr);
scope.signText.h = data.h;
scope.signText.depth = data.depth;
scope.signText.thickness = data.thickness;
scope.signText.font = data.font;
scope.signText.text = data.text;
scope.signText.degree = data.degree;
scope.fontsItemIndex = data.fontsItemIndex;


scope.showLoading = true;

setTimeout(function () {
scope.showLoading = false;
}, 50);
}
}
},


saveData() {
if (window.localStorage) {
let data = {};
data.h = this.signText.h;
data.depth = this.signText.depth;
data.thickness = this.signText.thickness;
data.font = this.signText.font;
data.text = this.signText.text;
data.fontsItemIndex = this.fontsItemIndex;
data.degree = this.signText.degree;

localStorage.setItem("signText", JSON.stringify(data));
}
},


loadlistBrand() {
const scope = this;
scope.loadData();


getThreeFonts(this).then(fontsDisp => {
scope.fontsData = fontsDisp;
scope.signText.font = scope.fontsData[1].fontName;
scope.refresh3d();
});
},

touchend() {
setTimeout(() => {
this.showLoading = false;
}, 1000);
},


handler(index) {
if (index === 0) {//文字
this.isreliefBtnIndex = index;
this.showText = true;

this.showFonts = false;
this.showSize = false;
this.showPrint = false;
this.btnsList[0].isClick = true;
this.btnsList[2].isClick = false;
this.btnsList[1].isClick = false;

this.updatedData();




return;
} else if (index === 1) {//字体
this.isreliefBtnIndex = index;

this.showFonts = true;
this.showSize = false;
this.showText = false;
this.showPrint = false;
this.btnsList[1].isClick = true;
this.btnsList[0].isClick = false;
this.btnsList[2].isClick = false;


this.updatedData();




return;
} else if (index === 2) {//尺寸
this.isreliefBtnIndex = index;
this.showSize = true;

this.showText = false;
this.showFonts = false;
this.showPrint = false;
this.btnsList[2].isClick = true;
this.btnsList[0].isClick = false;
this.btnsList[1].isClick = false;


this.updatedData();



return;
}
},


touchstart() {
this.isTopBtn();
this.updatedData();
},



isClickText() {
if (this.signText.text == "") {
this.$vux.toast.show({
text: '文本输入不能为空！',
type: "cancel",
time: 2000,
position: "middle",
});
this.showText = true;
return;
}
this.isTopBtn();
},

exporter() {
let exporter = new THREE.STLExporter();
let result = exporter.parse(currentModel, {
binary: true
});
let blob = new Blob([result], {
type: 'application/octet-stream'
});

let filename = "model.stl";
let link = document.createElement("a");
link.href = URL.createObjectURL(blob);
link.download = filename;
link.click();
},

refresh3d() {
updateModel(this, this.signText.font, this.signText.text, this.signText.h, this.signText.depth, this.signText.thickness)
.then(() => {

});
},

isTopBtn() {
this.isreliefBtnIndex = -1;
this.showSize = false;
this.showText = false;
this.showFonts = false;
this.showPrint = false;
this.btnsList[0].isClick = false;
this.btnsList[1].isClick = false;
this.btnsList[2].isClick = false;
},


onChangeText() {
if (this.signText.text === '' || this.signText.text === null) {
this.$vux.toast.show({
text: '文本输入不能为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.signText.text = "齐思印";
this.showText = true;
return;
}
console.log("文本输入:", this.signText.text);
this.isTopBtn();
this.refresh3d();
},


updatedData() {
if (this.signText.h == "" && this.signText.depth == "" && this.signText.thickness == "") {
this.$vux.toast.show({
text: '请检查输入是否为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showText = false;
this.showFonts = false;
this.showLoading = false;
} else if (this.signText.text == "") {
this.$vux.toast.show({
text: '请检查输入是否为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.showText = true;
this.showSize = false;
this.showFonts = false;
this.showLoading = false;
} else if (this.signText.h < 30) {
this.$vux.toast.show({
text: '最小长度为30毫米',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showLoading = false;
return;
} else if (this.signText.h > 800) {
this.$vux.toast.show({
text: '最大长度为800毫米',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showLoading = false;
return;
} else if (this.signText.depth < 2) {
this.$vux.toast.show({
text: '最小厚度为2毫米',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showLoading = false;
return;
} else if (this.signText.depth > 360) {
this.$vux.toast.show({
text: '最大厚度为360毫米',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showLoading = false;
return;
} else if (this.signText.thickness < 0.8) {
this.$vux.toast.show({
text: '最小壁厚为0.8毫米',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showLoading = false;
} else if (this.signText.thickness > 5) {
this.$vux.toast.show({
text: '最大壁厚为5毫米',
type: "warn",
time: 2000,
position: "middle",
});
this.showSize = true;
this.showLoading = false;
}
setTimeout(() => {
this.showLoading = false;
this.refresh3d();
}, 50);
},


cancelPop() {
this.isTopBtn();
this.updatedData();
},


isSure() {
this.isTopBtn();
this.showLoading = true;
this.updatedData();
},

isNoData() {
const scope = this;
if (scope.signText.h == "" && scope.signText.depth == "" && scope.signText.thickness == "") {
scope.$vux.toast.show({
text: '请检查输入是否为空！',
type: "warn",
time: 2000,
position: "middle",
});
scope.signText.h = 250;
scope.signText.depth = 10;
scope.signText.thickness = 1.5;
scope.showSize = true;
scope.showText = false;
scope.showFonts = false;
scope.showLoading = false;
} else if (scope.signText.text == "") {
scope.$vux.toast.show({
text: '请检查输入是否为空！',
type: "warn",
time: 2000,
position: "middle",
});
scope.signText.text = "齐思印";
scope.showText = true;
scope.showSize = false;
scope.showFonts = false;
scope.showLoading = false;
}
},


onfontsItemClick(index) {
const scope = this;
scope.showFonts = false;
scope.fontsItemIndex = index;
scope.showLoading = true;
scope.signText.font = scope.fontsData[scope.fontsItemIndex].fontName;


setTimeout(() => {
if (currentModel) {
scene.remove(currentModel);
currentModel.geometry.dispose();
}
scope.isTopBtn();
scope.showLoading = false;
scope.refresh3d();

}, 1000);
},


downloads() {
const scope = this;
scope.showLoading = true;

if (currentModel) {

if (!this.$common.getCookie('_token')) {

scope.saveData();

this.$router.push({
path: '/login',
query: {
fullPath: this.$route.fullPath
}
});
scope.showLoading = false;
} else {
scope.$request.post('/SmallSoftware/requestDownload', {
type: "word",
}).then(function (res) {
if (res.obj === true) {
scope.downloadModels();
setTimeout(() => {
scope.$vux.toast.show({
text: '下载成功',
type: "success",
time: 2000,
position: "middle",
});
scope.isTopBtn();
scope.showLoading = false;
}, 50);
} else {
scope.$vux.toast.show({
text: '下载失败',
type: "warn",
time: 2000,
position: "middle",
});
}
});
}
}
},


print() {
this.isTopBtn();
this.showLoading = true;





if (this.lowPrice == 0 && this.total <= 5 || this.total == 5) {
this.showlow = true;
this.showStyle = false;
this.showlowpriceHeight = true;
}
if (this.lowPrice == 1 && this.total > 5 || this.total > 5 || this.lowPrice == "") {
this.showlow = false;
this.showStyle = true;
this.showlowpriceHeight = false;
}

if (currentModel) {












this.saveData();
this.$nextTick(function () {
this.showPrint = true;
this.makeModelForPrint();
this.getPrice();
setTimeout(() => {
const scope = this;
scope.showLoading = false;
}, 50);
});

} else {
this.$vux.toast.show({
text: '3D招牌文字不能为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.refresh3d();
this.showLoading = false;
}
},

downloadModels() {
let exporter = new THREE.STLExporter();
let group = currentModel;

let result = exporter.parse(group, { binary: true });
let blob = new Blob([result], { type: 'application/octet-stream' });

let filename = "招牌文字.stl";
let link = document.createElement("a");
link.href = URL.createObjectURL(blob);
link.download = filename;
link.click();
},

makeStlBlob() {
let exporter = new THREE.STLExporter();
let result = exporter.parse(currentModel, { binary: true });
let blob = new Blob([result], { type: 'application/octet-stream' });
return blob;
},

getModelToPrint() { return currentModel; },
},
watch: {
'signText.text': function () {
if (this.signText.text == "") {
this.showbtnSure = false;
return;
} else {
this.showbtnSure = true;
}
},






},
}



// WEBPACK FOOTER //
// ./src/views/signText/scripts/signText.js